<template>
	<v-container fluid>
		<v-row
			justify = "center"
		>
			<v-col
				xl   = "11"
				lg 	 = "12"
				md 	 = "12"
				sm 	 = "12"
				xs 	 = "12"
				cols = "12"
			>			
			<!-- 11 -->
				<v-card outlined>
					<v-card-title
						
						class = "justify-center text-uppercase  pa-1 light-blue darken-4 white--text"
					>	
						<v-icon 				
							color  = "white"
							class  = "ml-1"
							@click = "$router.back()"
						>
							mdi-arrow-left-circle
						</v-icon>
						<v-spacer></v-spacer>
						<v-icon 
							
							color="white"
							class="mx-2"
							
						>
							mdi-cogs
						</v-icon>
						<span 
							v-text = "$ml.get('settings')" 
						></span>
						<v-spacer></v-spacer>
					</v-card-title>
					<!-- <v-divider></v-divider> -->
					<v-card-text class = "pt-1 mt-2">
						<v-row>
							<!-- sidebar options -->
							<v-col 
								xl   = "2"
								lg 	 = "2"
								md 	 = "2"
								sm 	 = "2"
								xs   = "2"
								cols = "12"
							>
							<!-- 2 -->
								<v-navigation-drawer dark permanent>
									<v-card >
											<v-card-title
												class = "pa-0 px-3 secondary body-1 text-uppercase font-weight-medium"
											>
												<v-icon 													
													class = "ml-2 mr-4"
												>														
													mdi-menu-open
												</v-icon>
												{{ $ml.get('options') }}
											</v-card-title>
									</v-card>
									<v-list dense>
								<template 
									v-for = "(item_option, key_option) of options_sidebar"
									v-if   = "item_option.enable && userCanView(getOptionPermissionName(item_option))"
								>								
											<v-list-item 
												dense 
												link 
												@click = "handleComponentSelection(item_option)"
												:key   = "key_option"
											>	

												<v-list-item-icon>
													<v-icon 
														small
													>														
														{{ item_option.icon }}
													</v-icon>
												</v-list-item-icon>
												<v-list-item-title 
													class = "caption text-uppercase"
													v-text = "item_option.title"
												></v-list-item-title>
											</v-list-item>
										</template>
									</v-list>
								</v-navigation-drawer>
							</v-col>
							<!-- content -->
							<v-col
								xl   = "10"
								lg 	 = "10"
								md 	 = "10"
								sm 	 = "10"
								xs   = "10"
								cols = "12"
							>	
								<component 
									v-if="selected.component && loadedComponents[selected.component]"
									:is 				 = "loadedComponents[selected.component] || selected.component"
									:info_component 	 = "selected.info"
									@info_from_component = "general_config[selected.component]=$event"
								></component>
								<v-skeleton-loader
									v-else
									type="card"
								></v-skeleton-loader>							
							</v-col>
						</v-row>
					</v-card-text>
					<!-- <v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							small
							color="primary"
							v-text="$ml.get('save')"
							@click="save"
						></v-btn>
					</v-card-actions> -->
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
	import axios 				from 'axios'
	// Lazy loading: solo cargar connections inicialmente, el resto se carga bajo demanda
	import connections 			from '@/components/general_parameters/connection_parameters.vue'
	
	export default{
		name: 'general_parameters',
		components: {
			connections, // Solo connections se carga inicialmente
		}, // components
		data: vm=>({
			// Cache de componentes cargados dinámicamente
			loadedComponents: {
				connections: connections, // Ya cargado
			},
			general_config: {},
			options_sidebar: [
					{ 
						title 		: 'TimeZone', 
						icon 		: 'mdi-map-clock',
						enable  	: true,
						to_select 	: 
							{ 
								component: 'time_zone', 
								info: {} 
							} 
					},
					{ 
						title 		: 'Connections',
						icon 		: 'mdi-network',
						enable 		: true,
						to_select 	: 
						{
							component: 'connections',
							info: {}
						},
					},
					{ 
						title 		: 'Logos',
						icon 		: 'mdi-folder-multiple-image',
						enable 		: false,
						to_select 	: 
						{
							component: 'logos',
							info: {}
						},
					},
					{ 
						title 		: 'Disks',
						icon 		: 'mdi-harddisk-plus',
						enable 		: true,
						to_select 	: 
						{
							component: 'disks',
							info: {}
						},
					}, 				
					{ 
						title 		: 'Recordings', 
						icon 		: 'mdi-album',
						enable  	: false,
						to_select 	: 
							{ 
								component: 'recordings', 
								info: {} 
							} 
					},	
					{ 
						title 		: 'Integration',
						icon 		: 'mdi-vector-intersection',
						enable 		: true,
						to_select 	: 
						{
							component: 'integration',
							info: {}
						},
					}, 
							
					{ 
						title 		: 'Stream', 
						icon 		: 'mdi-application-settings-outline',// view-stream
						enable  	: true,
						to_select 	: 
							{ 
								component: 'stream', 
								info: {} 
							} 
					},
					{ 
						title 		: 'Sounds', 
						icon 		: 'mdi-folder-music',
						enable  	: true,
						to_select 	: 
							{ 
								component: 'sounds', 
								info: {} 
							} 
					},
					{ 
						title 		: 'Whatsapp', 
						icon 		: 'mdi-whatsapp',
						enable 		: false,
						to_select 	: 
							{ 
								component: 'whatsapp', 
								info: {} 
							} 
					},
					
					{ 
						title 		: 'Modules', 
						icon 		: 'mdi-view-module',
						enable 		: false,
						to_select 	: 
							{ 
								component: 'modules', 
								info: {} 
							} 
					},					
					{ 
						title 		: 'Support', 
						icon 		: 'mdi-lifebuoy',
						enable 		: false,
						to_select 	: 
							{ 
								component: 'support', 
								info: {} 
							} 
					},
					{ 
						title 		: 'Workstations', 
						icon 		: 'mdi-monitor',
						enable 		: false,
						to_select 	: 
							{ 
								component: 'workspaces', 
								info: {} 
							} 
					},
					{ 
						title 		: 'Parameter', 
						icon 		: 'mdi-application-settings',
						enable 		: false,
						to_select 	: 
							{ 
								component: 'parameter', 
								info: {} 
							} 
					},
					
					
				],
						// { 
					// 	title: 'User Permissions', 
					// 	to_select: 
					// 		{ 
					// 			component: 'user_permissions', 
					// 			info: {} 
					// 		} 
					// },		
					/*{ 
						title: 'Locals', 
						to_select: 
							{ 
								component: 'locals', 
								info: {} 
							} 
					},*/
					/*{ 
						title: 'Licenses', 
						to_select: 
							{ 
								component: 'licenses', 
								info: {} 
							} 
					},
					{ 
						title: 'Assocatived devices', 
						to_select: 
							{ 
								component: 'assocatived_devices', 
								info: {} 
							} 
					},*/
			selected: { 
				component: 'connections',
				info: {}
				},
			header: [
				{ text: 'Component', value: 'component', align: 'center' },
				{ text: 'Type', value: 'type', align: 'center' },
				{ text: 'Route', value: 'route', align: 'center' },

			], // header
			info_routes: [			

			],
			default_routes:[
				{ component: 'Host', type: 'axios',route: '' },
				{ component: 'host_configuration', type: 'axios', route: '' },
				{ component: 'Devices', type: 'axios', route: '' },
				{ component: 'Event_LPR', type: 'axios', route: '' },
				{ component: 'Event_RFID', type: 'axios', route: '' },
				{ component: 'History_matches', type: 'axios', route:'' },
				{ component: 'device_config', type: 'axios', route:'' },
				{ component: 'mapview', type: 'socket', route:'' },
				{ component: 'toolbar', type: 'socket', route:'' },
				{ component: 'dashboard_face', type: 'axios', route: ''},
				{ component: 'dashboard_face', type: 'socket', route: ''},

			], 
			

		}), //data
		async created(){
			if (this.$store.state.auth.user){
	        // console.log(this.$store.state.auth.user.user.roleId, 'auth')
		        if (this.$store.state.auth.user.user.roleId == 3) {
		        	this.$router.push('dashboard')
		        }else if(this.$store.state.auth.user.user.roleId == 1){
		        	console.log("enable logos")
		      		console.log("logos route ", this.$route.name)
		      		if (this.$route.name == 'parameters') {
		      			let vm = this;
		      			let enable_list = ['Logos', 'Support', 'Recordings', 'Parameter'];
		      			vm.options_sidebar.forEach((option) => {
		      				if (option && enable_list.includes(option.title)) {
		      					option.enable = true;
		      					
		      				}
		      			})
		      		}else{
		      			let vm = this;
		      			let enable_list = ['Recordings', 'Workstations', 'Parameter'];
		      			vm.options_sidebar.forEach((option) => {
		      				if (option && enable_list.includes(option.title)) {
		      					option.enable = true;
		      					
		      				}
		      			})
		      		}
		        }
		      	}
		      	let get_config = null;
	      	if (localStorage.getItem('General_parameters')) {
	      		get_config = JSON.parse(localStorage.getItem('General_parameters'));
	      		// this.general_config=get_config;
	      	}
		      	this.general_config=get_config;	      
		      	this.options_sidebar[0].to_select.info=get_config;
			this.selectFirstVisibleOption();
			// Cargar el componente inicial permitido bajo demanda
			await this.loadComponent(this.selected.component);
		      
	      	// this.info_routes=this.default_routes;
	      	
		}, // created
		methods:{
			getOptionPermissionName(item){
				return item && item.to_select && item.to_select.component ? item.to_select.component : '';
			},

			userCanView(permissionName){
				if (!permissionName) {
					return false;
				}

				return this.$store.getters["auth/permission"](permissionName, "can_view");
			},

			visibleOptions(){
				return this.options_sidebar.filter(item => (
					item && item.enable && this.userCanView(this.getOptionPermissionName(item))
				));
			},

			selectFirstVisibleOption(){
				const selectedIsVisible = this.options_sidebar.some(item => (
					item &&
					item.to_select &&
					item.to_select.component == this.selected.component &&
					item.enable &&
					this.userCanView(this.getOptionPermissionName(item))
				));

				if (selectedIsVisible) {
					return;
				}

				const firstVisibleOption = this.visibleOptions()[0];
				if (firstVisibleOption) {
					this.selected = { ...firstVisibleOption.to_select };
				}
			},

			// Cargar componente bajo demanda (lazy loading)
			async loadComponent(componentName) {
				// Si ya está cargado, retornar
				if (this.loadedComponents[componentName]) {
					return this.loadedComponents[componentName];
				}

				// Mapeo de nombres de componentes a sus rutas
				const componentMap = {
					'connections': () => Promise.resolve(connections), // Ya importado
					'user_permissions': () => import('@/components/general_parameters/user_permissions.vue'),
					'modules': () => import('@/components/general_parameters/modules.vue'),
					'locals': () => import('@/components/general_parameters/locals.vue'),
					'licenses': () => import('@/components/general_parameters/licenses.vue'),
					'assocatived_devices': () => import('@/components/general_parameters/assocatived_devices.vue'),
					'time_zone': () => import('@/components/general_parameters/time_zone.vue'),
					'disks': () => import('@/components/general_parameters/disks.vue'),
					'stream': () => import('@/components/general_parameters/stream.vue'),
					'sounds': () => import('@/components/general_parameters/sounds.vue'),
					'logos': () => import('@/components/general_parameters/logos.vue'),
					'integration': () => import('@/components/general_parameters/integration_cloud.vue'),
					'support': () => import('@/components/general_parameters/support.vue'),
					'whatsapp': () => import('@/components/general_parameters/whatsapp.vue'),
					'recordings': () => import('@/components/general_parameters/recordings.vue'),
					'workspaces': () => import('@/components/general_parameters/workspaces.vue'),
					'parameter': () => import('@/components/general_parameters/parameter.vue'),
				};

				const loader = componentMap[componentName];
				if (loader) {
					try {
						const componentModule = await loader();
						const component = componentModule.default || componentModule;
						// Registrar el componente cargado en Vue
						this.$options.components[componentName] = component;
						this.loadedComponents[componentName] = component;
						return component;
					} catch (error) {
						console.error(`Error cargando componente ${componentName}:`, error);
						return null;
					}
				}
				return null;
			},

			// Manejar cambio de selección con carga bajo demanda
			async handleComponentSelection(option) {
				if (option && option.to_select && option.to_select.component) {
					const componentName = option.to_select.component;
					// Cargar componente si no está cargado
					const component = await this.loadComponent(componentName);
					if (component) {
						this.selected = option.to_select;
					} else {
						console.warn(`No se pudo cargar el componente: ${componentName}`);
					}
				}
			},

			save(){
				let data_config=this.general_config;
				if (!data_config.debug) {
					data_config.debug=false;
				}
				let api = this.$URL + '/api/v1/generalparameters';
				
				this.$axios.post(api,data_config).then( res => { 
					console.log(res.data)
				}).catch( error => {
					console.log(error)
				})
				let config = JSON.stringify(data_config);
				localStorage.setItem('General_parameters', config);
			}, // save

			get_list_roles(){
				let api = this.$URL+'/api/v1/role/';				
				this.$axios.get(api).then( res => {
					let items 		= res.data;
					let list_render = items.rows;
					if (list_render && list_render.length > 0) {

						for(let i = 0; i < list_render.length; i++){
							if (list_render[i].id == 1) {
								list_render[i].permission = 'CRUD';

							}else if(list_render[i].id == 2){
								list_render[i].permission = 'CRU';

							}else if(list_render[i].id == 3){
								list_render[i].permission = 'R';
							}
						}
					}else{
						console.warn("No found info roles");
					}
					console.log(list_render, 'list roles')
					// this.options_sidebar[1].to_select.info=list_render;
				}).catch( er =>{
					console.log(er, 'Error roles');
				});
			}, // get list roles
			
		}, // methods
		mounted(){
			// this.get_list_roles();
		
		}, // mounted
	};
</script>
